import { Hash, LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ContentCodeProps {
  code: string;
  icon?: LucideIcon;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
}

export function ContentCode({ 
  code, 
  icon: Icon = Hash, 
  className,
  iconClassName,
  textClassName 
}: ContentCodeProps) {
  return (
    <div className={cn("flex items-center", className)}>
      <Icon className={cn("h-4 w-4 text-muted-foreground", iconClassName)} />
      <span className={cn("text-sm text-muted-foreground", textClassName)}>{code}</span>
    </div>
  );
} 